export const GRAD    = '#5048E5';
export const fg      = 'hsl(var(--foreground))';
export const fgMuted = 'hsl(var(--muted-foreground))';
export const border  = 'hsl(var(--border))';
export const surface = 'hsl(var(--card))';
export const muted   = 'hsl(var(--muted))';

export type ProfileData = {
  name: string;
  email: string;
  image: string | null;
  isAdmin: boolean;
  bio: string | null;
  phone: string | null;
  website: string | null;
  age: number | null;
  createdAt: string;
};

export type SharedImage = {
  id: string;
  attachmentUrl: string;
  attachmentName: string | null;
  senderId: string;
  createdAt: string;
};

export function Field({
  label, icon, children,
}: { label: string; icon: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide"
        style={{ color: fgMuted, fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
        <span style={{ color: fgMuted }}>{icon}</span>
        {label}
      </label>
      {children}
    </div>
  );
}

export function InputStyle({ ...props }: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      className="w-full rounded-xl px-4 py-3 text-sm outline-none transition-all"
      style={{
        background: muted,
        border: `1px solid ${border}`,
        color: fg,
        fontFamily: 'Plus Jakarta Sans, sans-serif',
        ...(props.disabled ? { opacity: 0.55, cursor: 'not-allowed' } : {}),
      }}
    />
  );
}
